// Utility function to safely access deeply nested properties
const getNestedProperty = (item) => {
  return item.entity?.fieldBody[0]?.entity?.fieldPodcastEpisode?.entity || {};
};

// Utility function to sanitize JSON data
export const sanitizeJson = (data) => {
  return data.map(item => {
    if (item.entity && item.entity.fieldBody) {
      // eslint-disable-next-line no-param-reassign
      item.entity.fieldBody = item.entity.fieldBody.filter(
        field => Object.keys(field.entity).length !== 0,
      );
    }
    return item;
  });
};

// Utility function to reorder podcast episodes
export const reorderPodcastEpisodes = (data) => {
  return [...data].sort((a, b) => {
    const episodeNumberA = getNestedProperty(a).episodeNumber;
    const episodeNumberB = getNestedProperty(b).episodeNumber;
    return episodeNumberA - episodeNumberB;
  });
};

// Utility function to determine which seasons have episodes
export const getSeasonsWithEpisodes = (data) => {
  return new Set(
    data.map(item => getNestedProperty(item).fieldPartOfSeason?.toString()),
  );
};

// Utility function to generate season options dynamically from data
export const generateSeasonOptionsList = (seasonsWithEpisodes) => {
  return Array.from(seasonsWithEpisodes)
    .sort((a, b) => a - b)
    .map(seasonNumber => ({
      disabled: false,
      name: `Season ${seasonNumber}`,
      value: seasonNumber,
    }));
};

// Utility function to get the first date in a season
export const getSeasonDate = (data) => {
  if (data.length === 0) return undefined; // Check for empty array
  const nestedEntity = getNestedProperty(data[0]);
  return nestedEntity.datePublished;
};
